module.exports = __webpack_public_path__ + "media/img/pages/profile/lidl ger 3-f3b2fa9332a8c0689c9ac8f3b039731c.jpg";